import { useCallback } from "react";
import { Style } from "./helpers";
export const useStyle = (styles, prefix = '_modal-') => {
    return useCallback((style) => Style(style, styles, prefix), [styles, prefix]);
};
